/**
 * @fileoverview GET handler for the "/:app_group_id/operator_mcp_connections/:connection_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appGroupIdOperatorMcpConnectionsConnectionId } from "./constants";
import type {
  GetAppGroupIdOperatorMcpConnectionsConnectionIdProps,
  GetAppGroupIdOperatorMcpConnectionsConnectionIdResult,
} from "./types";
import { isGetAppGroupIdOperatorMcpConnectionsConnectionIdResult } from "./validators";

export const getAppGroupIdOperatorMcpConnectionsConnectionId = reactQueryFetcherAdapter(
  appGroupIdOperatorMcpConnectionsConnectionId,
  (
    signal: AbortSignal,
    { appGroupId, connectionId }: GetAppGroupIdOperatorMcpConnectionsConnectionIdProps
  ): Promise<GetAppGroupIdOperatorMcpConnectionsConnectionIdResult> => {
    // The connection's page shows its own error, as the list does.
    return fetch(
      `/${appGroupId}/operator_mcp_connections/${connectionId}`,
      "GET",
      {},
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetAppGroupIdOperatorMcpConnectionsConnectionIdResult
);
